window.customElements.define(
  'custom-video-component',
  class CustomVideoComponent extends window.HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.source = this.video.dataset.videoUrl;
      this.video.src = this.source;

      this.initVideoHandling();
    }

    initVideoHandling() {
      this.playVideo();

      ['touchstart', 'click', 'scroll'].forEach((event) => {
        document.addEventListener(
          event,
          () => {
            this.playVideo();
          },
          { passive: true, once: true }
        );
      });
    }

    playVideo() {
      const playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    }
  }
);
